import { onScroll, scrollTop } from "../utils/scroll";
import { currentBreakpointIndex } from "../utils/window-resize";

export function setupGalleries() {
    const galleries = document.querySelectorAll('[data-gallery]');
    const galleryObjects = [];

    galleries.forEach(gallery => {
        const images = gallery.querySelectorAll('[data-gallery-image]');
        galleryObjects.push({gallery, images});
    });

    onScroll(() => {
        galleryObjects.forEach(galleryObject => {
            if (galleryObject.gallery.classList.contains('intersected')) {
                galleryObject.images.forEach(image => {
                    const factor = image.getAttribute('data-top') / 100;
                    const factorSm = image.getAttribute('data-top-sm') / 100;

                    if (currentBreakpointIndex > 0) {
                        if (factorSm != 0) {
                            const translateY = ((scrollTop - parseInt(galleryObject.gallery.getAttribute('data-top'))) / 4) * (factorSm / 2);
                            image.style.transform = `translateZ(0) translateY(${translateY}px)`;
                        }
                    } else {
                        if (factor != 0) {
                            const translateY = ((scrollTop - parseInt(galleryObject.gallery.getAttribute('data-top'))) / 4) * (factor / 2);
                            image.style.transform = `translateZ(0) translateY(${translateY}px)`;
                        }
                    }
                });
            }
        });
    })
}
